/**
 * Copyright (C) 2016 Egylis,
 * Siège social, 46 rue René Clair, 75892 PARIS cedex 18 - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ('Confidential Information'). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 21/11/16.
 */

import {
    ArbreMachineMeta,
    ArbreTravailMeta,
    FilterValueMeta,
    I18nMeta,
    MachineMeta,
    MOEntity,
    MOEntityMeta,
    RouleauDocMeta,
    RouleauI18nMeta,
    RouleauMeta,
    RouleauNoteMeta, TravailMachineMeta
} from '../../common';


/**
 * Properties
 */
export class Constants {
    /**
     * TABLE_ONE_TIME
     */
    public static TABLE_ONE_TIME: Array<MOEntityMeta<MOEntity>> = [
        ArbreMachineMeta.instance,
        ArbreTravailMeta.instance,
        TravailMachineMeta.instance,
        FilterValueMeta.instance,
        I18nMeta.instance,
        MachineMeta.instance,
        RouleauDocMeta.instance,
        RouleauI18nMeta.instance,
        RouleauMeta.instance,
        RouleauNoteMeta.instance
    ];
}
